<template>
  <div>
    <Breadcrumbs main="Charts" title="ApexChart" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Basic Area Chart</h5>
            </div>
            <div class="card-body">
              <div id="basic-apex">
                <apexchart
                  height="350"
                  type="area"
                  :options="basicareachart.options"
                  :series="basicareachart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Area Spaline Chart</h5>
            </div>
            <div class="card-body">
              <div id="area-spaline">
                <apexchart
                  height="350"
                  type="area"
                  :options="areaspalinechart.chartOptions"
                  :series="areaspalinechart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Bar chart</h5>
            </div>
            <div class="card-body">
              <div id="basic-bar">
                <apexchart
                  height="350"
                  type="bar"
                  :options="basiccbarchart.chartOptions"
                  :series="basiccbarchart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Column Chart</h5>
            </div>
            <div class="card-body">
              <div id="column-chart">
                <apexchart
                  height="350"
                  type="bar"
                  :options="columnchart.chartOptions"
                  :series="columnchart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-12">
          <div class="card">
            <div class="card-header">
              <h5>
                3d Bubble Chart
              </h5>
            </div>
            <div class="card-body">
              <div id="chart-bubble">
                <apexchart
                  height="350"
                  type="bubble"
                  :options="bubblechart.chartOptions"
                  :series="bubblechart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Stepline Chart</h5>
            </div>
            <div class="card-body">
              <div id="stepline">
                <apexchart
                  height="350"
                  type="line"
                  :options="steplinechart.chartOptions"
                  :series="steplinechart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Column Chart</h5>
            </div>
            <div class="card-body">
              <div id="annotationchart">
                <apexchart
                  height="350"
                  type="line"
                  :options="annotationchart.chartOptions"
                  :series="annotationchart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Pie Chart</h5>
            </div>
            <div class="card-body apex-chart">
              <div id="piechart">
                <apexchart
                  width="380"
                  type="pie"
                  :options="piechart.chartOptions"
                  :series="piechart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Donut Chart</h5>
            </div>
            <div class="card-body apex-chart">
              <div id="donutchart">
                <apexchart
                  width="380"
                  type="donut"
                  :options="donutchart.chartOptions"
                  :series="donutchart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12 box-col-12">
          <div class="card">
            <div class="card-header">
              <h5>Mixed Chart</h5>
            </div>
            <div class="card-body">
              <div id="mixedchart">
                <apexchart
                  height="350"
                  type="line"
                  :options="mixedchart.chartOptions"
                  :series="mixedchart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12 box-col-12">
          <div class="card">
            <div class="card-header">
              <h5>Candlestick Chart</h5>
            </div>
            <div class="card-body">
              <div id="candlestick">
                <apexchart
                  height="350"
                  type="candlestick"
                  :options="candlestick.chartOptions"
                  :series="candlestick.series"
                  :plotOptions="candlestick.plotOptions"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Radar Chart</h5>
            </div>
            <div class="card-body">
              <div id="radarchart">
                <apexchart
                  height="350"
                  type="radar"
                  :options="radarchart.chartOptions"
                  :series="radarchart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 box-col-6">
          <div class="card">
            <div class="card-header">
              <h5>Radial Bar Chart</h5>
            </div>
            <div class="card-body apex-chart">
              <div id="circlechart">
                <apexchart
                  height="320"
                  type="radialBar"
                  :options="circlechart.chartOptions"
                  :series="circlechart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var primary = localStorage.getItem('primary_color') || '#7366ff';
  var secondary = localStorage.getItem('secondary_color') || '#f73164';

  export default {
    data() {
      return {
        basicareachart: {
          options: {
            chart: {
              type: 'area',
              height: 350,
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
            },
            colors: [primary],
            title: {
              text: 'Fundamental Analysis of Stocks',
              align: 'left',
            },
            subtitle: {
              text: 'Price Movements',
              align: 'left',
            },
            labels: [
              '13 Nov 2017',
              '14 Nov 2017',
              '15 Nov 2017',
              '16 Nov 2017',
              '17 Nov 2017',
              '20 Nov 2017',
              '21 Nov 2017',
              '22 Nov 2017',
              '23 Nov 2017',
              '24 Nov 2017',
              '27 Nov 2017',
              '28 Nov 2017',
              '29 Nov 2017',
              '30 Nov 2017',
              '01 Dec 2017',
              '04 Dec 2017',
              '05 Dec 2017',
              '06 Dec 2017',
              '07 Dec 2017',
              '08 Dec 2017',
            ],
            xaxis: {
              type: 'datetime',
            },
            yaxis: {
              opposite: true,
            },
            legend: {
              horizontalAlign: 'left',
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
          series: [
            {
              name: 'STOCK ABC',
              data: [
                8107.85,
                8128.0,
                8122.9,
                8165.5,
                8340.7,
                8423.7,
                8423.5,
                8514.3,
                8481.85,
                8487.7,
                8506.9,
                8626.2,
                8668.95,
                8602.3,
                8607.55,
                8512.9,
                8496.25,
                8600.65,
                8881.1,
                9340.85,
              ],
            },
          ],
        },
        areaspalinechart: {
          series: [
            {
              name: 'series1',
              data: [31, 40, 28, 51, 42, 109, 100],
            },
            {
              name: 'series2',
              data: [11, 32, 45, 32, 34, 52, 41],
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'area',
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
            },
            colors: [primary, secondary],
            xaxis: {
              type: 'datetime',
              categories: [
                '2018-09-19T00:00:00.000Z',
                '2018-09-19T01:30:00.000Z',
                '2018-09-19T02:30:00.000Z',
                '2018-09-19T03:30:00.000Z',
                '2018-09-19T04:30:00.000Z',
                '2018-09-19T05:30:00.000Z',
                '2018-09-19T06:30:00.000Z',
              ],
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy HH:mm',
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        basiccbarchart: {
          series: [
            {
              data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
            },
          ],
          chartOptions: {
            chart: {
              type: 'bar',
              height: 350,
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
            },
            colors: [primary],
            xaxis: {
              categories: [
                'South Korea',
                'Canada',
                'United Kingdom',
                'Netherlands',
                'Italy',
                'France',
                'Japan',
                'United States',
                'China',
                'Germany',
              ],
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        columnchart: {
          series: [
            {
              name: 'Net Profit',
              data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
            },
            {
              name: 'Revenue',
              data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
            },
            {
              name: 'Free Cash Flow',
              data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
            },
          ],
          chartOptions: {
            chart: {
              type: 'bar',
              height: 350,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent'],
            },
            colors: [primary, secondary, '#51bb25'],
            xaxis: {
              categories: [
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
              ],
            },
            yaxis: {
              title: {
                text: '$ (thousands)',
              },
            },
            fill: {
              opacity: 1,
            },
            tooltip: {
              y: {
                formatter: function(val) {
                  return '$ ' + val + ' thousands';
                },
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        bubblechart: {
          series: [
            {
              name: 'Product1',
              data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
                min: 10,
                max: 60,
              }),
            },
            {
              name: 'Product2',
              data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
                min: 10,
                max: 60,
              }),
            },
            {
              name: 'Product3',
              data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
                min: 10,
                max: 60,
              }),
            },
            {
              name: 'Product4',
              data: this.generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
                min: 10,
                max: 60,
              }),
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'bubble',
            },
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'gradient',
            },
            colors: [primary, secondary, '#51bb25', '#f8d62b'],
            title: {
              text: '3D Bubble Chart',
            },
            xaxis: {
              tickAmount: 12,
              type: 'datetime',
              labels: {
                rotate: 0,
              },
            },
            yaxis: {
              max: 70,
            },
            theme: {
              palette: 'palette2',
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        steplinechart: {
          series: [
            {
              data: [34, 44, 54, 21, 12, 43, 33, 23, 66, 66, 58],
            },
          ],
          chartOptions: {
            chart: {
              type: 'line',
              height: 350,
            },
            stroke: {
              curve: 'stepline',
            },
            colors: [primary],
            dataLabels: {
              enabled: false,
            },
            title: {
              text: 'Stepline Chart',
              align: 'left',
            },
            markers: {
              hover: {
                sizeOffset: 4,
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        annotationchart: {
          series: [
            {
              data: [
                8107.85,
                8128.0,
                8122.9,
                8165.5,
                8340.7,
                8423.7,
                8423.5,
                8514.3,
                8481.85,
                8487.7,
                8506.9,
                8626.2,
                8668.95,
                8602.3,
                8607.55,
                8512.9,
                8496.25,
                8600.65,
                8881.1,
                9340.85,
              ],
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              id: 'areachart-2',
            },
            annotations: {
              yaxis: [
                {
                  y: 8200,
                  borderColor: '#00E396',
                  label: {
                    borderColor: '#00E396',
                    style: {
                      color: '#fff',
                      background: '#00E396',
                    },
                    text: 'Support',
                  },
                },
                {
                  y: 8600,
                  y2: 9000,
                  borderColor: '#000',
                  fillColor: '#FEB019',
                  opacity: 0.2,
                  label: {
                    borderColor: '#333',
                    style: {
                      fontSize: '10px',
                      color: '#333',
                      background: '#FEB019',
                    },
                    text: 'Y-axis range',
                  },
                },
              ],
              xaxis: [
                {
                  x: new Date('23 Nov 2017').getTime(),
                  strokeDashArray: 0,
                  borderColor: '#775DD0',
                  label: {
                    borderColor: '#775DD0',
                    style: {
                      color: '#fff',
                      background: '#775DD0',
                    },
                    text: 'Anno Test',
                  },
                },
                {
                  x: new Date('26 Nov 2017').getTime(),
                  x2: new Date('28 Nov 2017').getTime(),
                  fillColor: '#B3F7CA',
                  opacity: 0.4,
                  label: {
                    borderColor: '#B3F7CA',
                    style: {
                      fontSize: '10px',
                      color: '#fff',
                      background: '#00E396',
                    },
                    offsetY: -10,
                    text: 'X-axis range',
                  },
                },
              ],
              points: [
                {
                  x: new Date('01 Dec 2017').getTime(),
                  y: 8607.55,
                  marker: {
                    size: 8,
                    fillColor: '#fff',
                    strokeColor: 'red',
                    radius: 2,
                    cssClass: 'apexcharts-custom-class',
                  },
                  label: {
                    borderColor: '#FF4560',
                    offsetY: 0,
                    style: {
                      color: '#fff',
                      background: '#FF4560',
                    },

                    text: 'Point Annotation',
                  },
                },
                {
                  x: new Date('08 Dec 2017').getTime(),
                  y: 9340.85,
                  marker: {
                    size: 0,
                  },
                },
              ],
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
            },
            colors: [primary],
            grid: {
              padding: {
                right: 30,
                left: 20,
              },
            },
            title: {
              text: 'Line with Annotations',
              align: 'left',
            },
            labels: [
              '13 Nov 2017',
              '14 Nov 2017',
              '15 Nov 2017',
              '16 Nov 2017',
              '17 Nov 2017',
              '20 Nov 2017',
              '21 Nov 2017',
              '22 Nov 2017',
              '23 Nov 2017',
              '24 Nov 2017',
              '27 Nov 2017',
              '28 Nov 2017',
              '29 Nov 2017',
              '30 Nov 2017',
              '01 Dec 2017',
              '04 Dec 2017',
              '05 Dec 2017',
              '06 Dec 2017',
              '07 Dec 2017',
              '08 Dec 2017',
            ],
            xaxis: {
              type: 'datetime',
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        piechart: {
          series: [44, 55, 13, 43, 22],
          chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
            },
            labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: 'bottom',
                    fontSize: '9px'
                  },
                },
              },
            ],
            colors: [primary, secondary, '#51bb25', '#a927f9', '#f8d62b'],
          },
        },
        donutchart: {
          series: [44, 55, 41, 17, 15],
          chartOptions: {
            chart: {
              type: 'donut',
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: 'bottom',
                  },
                },
              },
            ],
            colors: [primary, secondary, '#51bb25', '#a927f9', '#f8d62b'],
          },
        },
        mixedchart: {
          series: [
            {
              name: 'Column',
              type: 'column',
              data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
            },
            {
              name: 'Area',
              type: 'area',
              data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
            },
            {
              name: 'Line',
              type: 'line',
              data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              stacked: false,
            },
            stroke: {
              width: [0, 2, 5],
              curve: 'smooth',
            },
            colors: [primary, '#51bb25', secondary],
            plotOptions: {
              bar: {
                columnWidth: '50%',
              },
            },
            fill: {
              opacity: [0.85, 0.25, 1],
              gradient: {
                inverseColors: false,
                shade: 'light',
                type: 'vertical',
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100],
              },
            },
            labels: [
              '01/01/2003',
              '02/01/2003',
              '03/01/2003',
              '04/01/2003',
              '05/01/2003',
              '06/01/2003',
              '07/01/2003',
              '08/01/2003',
              '09/01/2003',
              '10/01/2003',
              '11/01/2003',
            ],
            markers: {
              size: 0,
            },
            xaxis: {
              type: 'datetime',
            },
            yaxis: {
              title: {
                text: 'Points',
              },
              min: 0,
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function(y) {
                  if (typeof y !== 'undefined') {
                    return y.toFixed(0) + ' points';
                  }
                  return y;
                },
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        candlestick: {
          series: [
            {
              name: 'candle',
              data: [
                {
                  x: new Date(1538778600000),
                  y: [6629.81, 6650.5, 6623.04, 6633.33],
                },
                {
                  x: new Date(1538780400000),
                  y: [6632.01, 6643.59, 6620, 6630.11],
                },
                {
                  x: new Date(1538782200000),
                  y: [6630.71, 6648.95, 6623.34, 6635.65],
                },
                {
                  x: new Date(1538784000000),
                  y: [6635.65, 6651, 6629.67, 6638.24],
                },
                {
                  x: new Date(1538785800000),
                  y: [6638.24, 6640, 6620, 6624.47],
                },
                {
                  x: new Date(1538787600000),
                  y: [6624.53, 6636.03, 6621.68, 6624.31],
                },
                {
                  x: new Date(1538789400000),
                  y: [6624.61, 6632.2, 6617, 6626.02],
                },
                {
                  x: new Date(1538791200000),
                  y: [6627, 6627.62, 6584.22, 6603.02],
                },
                {
                  x: new Date(1538793000000),
                  y: [6605, 6608.03, 6598.95, 6604.01],
                },
                {
                  x: new Date(1538794800000),
                  y: [6604.5, 6614.4, 6602.26, 6608.02],
                },
                {
                  x: new Date(1538796600000),
                  y: [6608.02, 6610.68, 6601.99, 6608.91],
                },
                {
                  x: new Date(1538798400000),
                  y: [6608.91, 6618.99, 6608.01, 6612],
                },
                {
                  x: new Date(1538800200000),
                  y: [6612, 6615.13, 6605.09, 6612],
                },
                {
                  x: new Date(1538802000000),
                  y: [6612, 6624.12, 6608.43, 6622.95],
                },
                {
                  x: new Date(1538803800000),
                  y: [6623.91, 6623.91, 6615, 6615.67],
                },
                {
                  x: new Date(1538805600000),
                  y: [6618.69, 6618.74, 6610, 6610.4],
                },
                {
                  x: new Date(1538807400000),
                  y: [6611, 6622.78, 6610.4, 6614.9],
                },
                {
                  x: new Date(1538809200000),
                  y: [6614.9, 6626.2, 6613.33, 6623.45],
                },
                {
                  x: new Date(1538811000000),
                  y: [6623.48, 6627, 6618.38, 6620.35],
                },
                {
                  x: new Date(1538812800000),
                  y: [6619.43, 6620.35, 6610.05, 6615.53],
                },
                {
                  x: new Date(1538814600000),
                  y: [6615.53, 6617.93, 6610, 6615.19],
                },
                {
                  x: new Date(1538816400000),
                  y: [6615.19, 6621.6, 6608.2, 6620],
                },
                {
                  x: new Date(1538818200000),
                  y: [6619.54, 6625.17, 6614.15, 6620],
                },
                {
                  x: new Date(1538820000000),
                  y: [6620.33, 6634.15, 6617.24, 6624.61],
                },
                {
                  x: new Date(1538821800000),
                  y: [6625.95, 6626, 6611.66, 6617.58],
                },
                {
                  x: new Date(1538823600000),
                  y: [6619, 6625.97, 6595.27, 6598.86],
                },
                {
                  x: new Date(1538825400000),
                  y: [6598.86, 6598.88, 6570, 6587.16],
                },
                {
                  x: new Date(1538827200000),
                  y: [6588.86, 6600, 6580, 6593.4],
                },
                {
                  x: new Date(1538829000000),
                  y: [6593.99, 6598.89, 6585, 6587.81],
                },
                {
                  x: new Date(1538830800000),
                  y: [6587.81, 6592.73, 6567.14, 6578],
                },
                {
                  x: new Date(1538832600000),
                  y: [6578.35, 6581.72, 6567.39, 6579],
                },
                {
                  x: new Date(1538834400000),
                  y: [6579.38, 6580.92, 6566.77, 6575.96],
                },
                {
                  x: new Date(1538836200000),
                  y: [6575.96, 6589, 6571.77, 6588.92],
                },
                {
                  x: new Date(1538838000000),
                  y: [6588.92, 6594, 6577.55, 6589.22],
                },
                {
                  x: new Date(1538839800000),
                  y: [6589.3, 6598.89, 6589.1, 6596.08],
                },
                {
                  x: new Date(1538841600000),
                  y: [6597.5, 6600, 6588.39, 6596.25],
                },
                {
                  x: new Date(1538843400000),
                  y: [6598.03, 6600, 6588.73, 6595.97],
                },
                {
                  x: new Date(1538845200000),
                  y: [6595.97, 6602.01, 6588.17, 6602],
                },
                {
                  x: new Date(1538847000000),
                  y: [6602, 6607, 6596.51, 6599.95],
                },
                {
                  x: new Date(1538848800000),
                  y: [6600.63, 6601.21, 6590.39, 6591.02],
                },
                {
                  x: new Date(1538850600000),
                  y: [6591.02, 6603.08, 6591, 6591],
                },
                {
                  x: new Date(1538852400000),
                  y: [6591, 6601.32, 6585, 6592],
                },
                {
                  x: new Date(1538854200000),
                  y: [6593.13, 6596.01, 6590, 6593.34],
                },
                {
                  x: new Date(1538856000000),
                  y: [6593.34, 6604.76, 6582.63, 6593.86],
                },
                {
                  x: new Date(1538857800000),
                  y: [6593.86, 6604.28, 6586.57, 6600.01],
                },
                {
                  x: new Date(1538859600000),
                  y: [6601.81, 6603.21, 6592.78, 6596.25],
                },
                {
                  x: new Date(1538861400000),
                  y: [6596.25, 6604.2, 6590, 6602.99],
                },
                {
                  x: new Date(1538863200000),
                  y: [6602.99, 6606, 6584.99, 6587.81],
                },
                {
                  x: new Date(1538865000000),
                  y: [6587.81, 6595, 6583.27, 6591.96],
                },
                {
                  x: new Date(1538866800000),
                  y: [6591.97, 6596.07, 6585, 6588.39],
                },
                {
                  x: new Date(1538868600000),
                  y: [6587.6, 6598.21, 6587.6, 6594.27],
                },
                {
                  x: new Date(1538870400000),
                  y: [6596.44, 6601, 6590, 6596.55],
                },
                {
                  x: new Date(1538872200000),
                  y: [6598.91, 6605, 6596.61, 6600.02],
                },
                {
                  x: new Date(1538874000000),
                  y: [6600.55, 6605, 6589.14, 6593.01],
                },
                {
                  x: new Date(1538875800000),
                  y: [6593.15, 6605, 6592, 6603.06],
                },
                {
                  x: new Date(1538877600000),
                  y: [6603.07, 6604.5, 6599.09, 6603.89],
                },
                {
                  x: new Date(1538879400000),
                  y: [6604.44, 6604.44, 6600, 6603.5],
                },
                {
                  x: new Date(1538881200000),
                  y: [6603.5, 6603.99, 6597.5, 6603.86],
                },
                {
                  x: new Date(1538883000000),
                  y: [6603.85, 6605, 6600, 6604.07],
                },
                {
                  x: new Date(1538884800000),
                  y: [6604.98, 6606, 6604.07, 6606],
                },
              ],
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'candlestick',
            },
            title: {
              text: 'CandleStick Chart - Category X-axis',
              align: 'left',
            },
            annotations: {
              xaxis: [
                {
                  x: 'Oct 06 14:00',
                  borderColor: '#00E396',
                  label: {
                    borderColor: '#00E396',
                    style: {
                      fontSize: '12px',
                      color: '#fff',
                      background: '#00E396',
                    },
                    orientation: 'horizontal',
                    offsetY: 7,
                    text: 'Annotation Test',
                  },
                },
              ],
            },
            tooltip: {
              enabled: true,
            },
            xaxis: {
              type: 'datetime',
            },
            yaxis: {
              tooltip: {
                enabled: true,
              },
            },
            plotOptions: {
              candlestick: {
                colors: {
                  upward: primary,
                  downward: secondary,
                },
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        radarchart: {
          series: [
            {
              name: 'Series 1',
              data: [20, 100, 40, 30, 50, 80, 33],
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'radar',
            },
            dataLabels: {
              enabled: true,
            },
            plotOptions: {
              radar: {
                size: 140,
                polygons: {
                  strokeColors: '#e9e9e9',
                  fill: {
                    colors: ['#f8f8f8', '#fff'],
                  },
                },
              },
            },
            title: {
              text: 'Radar with Polygon Fill',
            },
            colors: [secondary],
            markers: {
              size: 4,
              colors: ['#fff'],
              strokeColor: secondary,
              strokeWidth: 2,
            },
            tooltip: {
              y: {
                formatter: function(val) {
                  return val;
                },
              },
            },
            xaxis: {
              categories: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
              ],
            },
            yaxis: {
              tickAmount: 7,
              labels: {
                formatter: function(val, i) {
                  if (i % 2 === 0) {
                    return val;
                  } else {
                    return '';
                  }
                },
              },
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        },
        circlechart: {
          series: [44, 55, 67, 83],
          chartOptions: {
            chart: {
              height: 350,
              type: 'radialBar',
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    height: 220,
                    width: 280,
                  },
                  legend: {
                    position: 'bottom',
                  },
                },
              },
            ],
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    fontSize: '22px',
                  },
                  value: {
                    fontSize: '16px',
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function() {
                      // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                      return 249;
                    },
                  },
                },
              },
            },
            labels: ['Apples', 'Oranges', 'Bananas', 'Berries'],
            colors: [secondary, '#51bb25', '#f8d62b', primary],
          },
        },
      };
    },
    methods: {
      generateData(baseval, count, yrange) {
        var i = 0;
        var series = [];
        while (i < count) {
          var y =
            Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
            yrange.min;
          var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

          series.push([baseval, y, z]);
          baseval += 86400000;
          i++;
        }
        return series;
      },
    },
  };
</script>

<style scoped></style>
